// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3zA61ZuuwkaY7dJE4i9zOW","small":"_3a-r3F34-mDlxMhjsL5sZT","medium":"SKO9j6bpUtYfNY1hgmghu","large":"Om5f5MWa8XcUdP6kL__tw"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/components/utilities/SpinnerCrimp.scss
// module id = 580
// module chunks = 0